module.exports = __webpack_public_path__ + "img/thumbnail.4ad1cece.jpg";